// src/pages/grupos/GrupoDetalhe.jsx
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import api from "../../services/api";
import { AuthContext } from "../../context/AuthContext";

export default function GrupoDetalhe() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { user, initializing } = useContext(AuthContext);

    const [grupo, setGrupo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [meuId, setMeuId] = useState(null);
    const [meuMembro, setMeuMembro] = useState(null);
    const [membroSelecionado, setMembroSelecionado] = useState(null);

    useEffect(() => {
        if (initializing) {
            setLoading(true);
            return;
        }

        if (!user) {
            setLoading(false);
            return;
        }

        const currentUserId = Number(user.id);
        setMeuId(currentUserId);

        const loadGrupo = async () => {
            try {
                const r = await api.get(`/grupos/${id}/`);
                setGrupo(r.data);

                const membros = Array.isArray(r.data.membros) ? r.data.membros : [];

                const meuRegistro = membros.find((m) => {
                    let alunoId = m.aluno;
                    if (alunoId && typeof alunoId === "object") {
                        alunoId = alunoId.id;
                    }
                    return Number(alunoId) === currentUserId;
                });

                setMeuMembro(meuRegistro);

                const criadorId = Number(r.data.criador);

                if (!meuRegistro && criadorId !== currentUserId) {
                    navigate("/grupos");
                    return;
                }
            } catch (e) {
                if (e.response && (e.response.status === 404 || e.response.status === 403)) {
                    navigate("/grupos");
                }
            } finally {
                setLoading(false);
            }
        };

        loadGrupo();
    }, [id, navigate, user, initializing]);

    // ----------------------------------------------------------
    // Modal de remoção
    // ----------------------------------------------------------
    const openModalRemocao = (membro) => {
        setMembroSelecionado(membro);
        const modalElement = document.getElementById("modalRemoverMembro");
        if (modalElement) {
            const modal = new window.bootstrap.Modal(modalElement);
            modal.show();
        }
    };

    const confirmarRemocao = async () => {
        if (!membroSelecionado) return;

        const modalElement = document.getElementById("modalRemoverMembro");
        if (modalElement) {
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) modal.hide();
        }

        try {
            await api.post(`/grupos/${id}/remover/${membroSelecionado.id}/`);

            const element = document.getElementById(`membro-${membroSelecionado.id}`);
            if (element) element.classList.add("fade-out");

            setTimeout(() => {
                api.get(`/grupos/${id}/`)
                    .then((r) => {
                        setGrupo(r.data);
                        const meuRegistro = r.data.membros.find(
                            (m) => Number(m.aluno) === Number(meuId)
                        );
                        setMeuMembro(meuRegistro);
                    });
            }, 500);
        } catch (e) {
            const detail = e.response?.data?.detail || "Não foi possível remover o membro.";
            alert(`Erro: ${detail}`);
        }
    };

    // ----------------------------------------------------------
    // Modal sair do grupo
    // ----------------------------------------------------------
    const openModalSaida = () => {
        const modalElement = document.getElementById("modalSairDoGrupo");
        if (modalElement) {
            const modal = new window.bootstrap.Modal(modalElement);
            modal.show();
        }
    };

    const fecharModalSaida = () => {
        const modalElement = document.getElementById("modalSairDoGrupo");
        if (modalElement) {
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) modal.hide();
        }
    };

    const confirmarSaida = async () => {
        fecharModalSaida();

        try {
            await api.post(`/grupos/${id}/sair/`);
            navigate("/grupos");
        } catch (e) {
            const detail = e.response?.data?.detail || "Erro ao sair do grupo.";
            alert(`Erro: ${detail}`);
        }
    };

    // ----------------------------------------------------------
    // ORDENAR MEMBROS (lista normal)
    // ----------------------------------------------------------
    const ordenarMembros = (membros) => {
        if (!grupo) return [];
        return [...membros].sort((a, b) => {
            if (a.aluno === grupo.criador) return -1;
            if (b.aluno === grupo.criador) return 1;

            if (b.emojis_hoje.length !== a.emojis_hoje.length)
                return b.emojis_hoje.length - a.emojis_hoje.length;

            if (b.emojis_semana.length !== a.emojis_semana.length)
                return b.emojis_semana.length - a.emojis_semana.length;

            return b.checkins - a.checkins;
        });
    };

    // ----------------------------------------------------------
    // GERAR RANKING PARA O PÓDIO
    // ----------------------------------------------------------
    const gerarRanking = (membros) => {
        if (!grupo) return [];

        const listaOrdenada = [...membros].sort((a, b) => {
            if (b.checkins !== a.checkins) return b.checkins - a.checkins;

            if (b.emojis_hoje.length !== a.emojis_hoje.length)
                return b.emojis_hoje.length - a.emojis_hoje.length;

            if (b.emojis_semana.length !== a.emojis_semana.length)
                return b.emojis_semana.length - a.emojis_semana.length;

            return 0;
        });

        return listaOrdenada.slice(0, 3);
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="container mt-4">
                    <p>Carregando...</p>
                </div>
            </>
        );
    }

    return (
        <>
            <Navbar />

            <div className="container mt-4">
                {!grupo ? (
                    <p>Grupo não encontrado ou você não é membro ativo.</p>
                ) : (
                    <>
                        {/* HEADER*/}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h2 className="fw-bold mb-0">{grupo.nome}</h2>
                            <span
                                className={"badge " + (grupo.publico ? "bg-success" : "bg-secondary")}
                            >
                                {grupo.publico ? "Grupo público" : "Grupo privado"}
                            </span>
                        </div>

                        {/* CARD PRINCIPAL*/}
                        <div className="card shadow-sm p-4 mb-4">
                            {grupo.imagem_capa && (
                                <img
                                    src={grupo.imagem_capa}
                                    className="rounded mb-3"
                                    style={{
                                        width: "100%",
                                        maxHeight: "250px",
                                        objectFit: "cover",
                                    }}
                                    alt={`Capa do grupo ${grupo.nome}`}
                                />
                            )}

                            <p><strong>Objetivo:</strong> {grupo.objetivo}</p>

                            <p className="mb-2">
                                <strong>WhatsApp:</strong>{" "}
                                {grupo.link_whatsapp ? (
                                    <a href={grupo.link_whatsapp} target="_blank" rel="noopener noreferrer">acessar grupo</a>
                                ) : (
                                    "Nenhum link informado."
                                )}
                            </p>

                            <p>
                                <strong>Criador:</strong> {grupo.criador_nome}{" "}
                                {Number(grupo.criador) === Number(meuId) && (
                                    <span className="badge bg-info">VOCÊ</span>
                                )}
                            </p>

                            <div className="d-flex gap-2 mt-3">
                                {!grupo.publico && meuMembro && (
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => navigate(`/grupos/${id}/convidar`)}
                                    >
                                        Convidar membros
                                    </button>
                                )}

                                {Number(meuId) !== Number(grupo.criador) && meuMembro && (
                                    <button
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={openModalSaida}
                                    >
                                        Sair do grupo
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* =====================
                                PÓDIO DO GRUPO
                            ===================== */}
                          {grupo?.membros && (
                            <div className="card mb-4 shadow-sm">
                              <div className="card-body">
                                <h5 className="fw-bold mb-3">Ranking do Grupo</h5>

                                {(() => {
                                  const ranking = gerarRanking(grupo.membros);
                                  if (!ranking.length)
                                    return <p>Nenhum membro ranqueado ainda.</p>;

                                  const medalhas = ["🥇", "🥈", "🥉"];

                                  return (
                                    <div className="row text-center">
                                      {ranking.map((m, i) => (
                                        <div key={m.id} className="col-md-4 mb-3">
                                          <div className="border rounded p-3 h-100">

                                            {/* Nome + medalha */}
                                            <h6 className="fw-bold" style={{ fontSize: "1.1rem" }}>
                                              {medalhas[i]} {m.nome}
                                            </h6>

                                            {/* Check-ins totais */}
                                            <p className="mb-0">
                                              <strong>Check-ins:</strong> {m.checkins}
                                            </p>

                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  );
                                })()}
                              </div>
                            </div>
                          )}


                        {/* =====================
                             LISTA DE MEMBROS
                           ===================== */}
                        <h4 className="fw-bold mb-3">Membros ({grupo.membros.length})</h4>

                        <div className="list-group mb-5">
                            {ordenarMembros(grupo.membros).map((m) => (
                                <div
                                    key={m.id}
                                    id={`membro-${m.id}`}
                                    className="list-group-item d-flex align-items-center justify-content-between"
                                >
                                    <div className="d-flex align-items-center">
                                        <img
                                            src={m.foto || `https://ui-avatars.com/api/?name=${encodeURIComponent(m.nome)}&size=48&background=6366f1&color=fff&bold=true`}
                                            width={48}
                                            height={48}
                                            className="rounded-circle me-3"
                                            style={{ objectFit: "cover" }}
                                            alt={`Foto de ${m.nome}`}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(m.nome)}&size=48&background=6366f1&color=fff&bold=true`;
                                            }}
                                        />

                                        <div>
                                            <Link
                                                to={m.perfil_publico_url}
                                                className="fw-bold text-decoration-none"
                                            >
                                                {m.nome}{" "}
                                                {Number(m.aluno) === Number(grupo.criador) && (
                                                    <span className="badge bg-warning text-dark">Criador</span>
                                                )}
                                                {Number(m.aluno) === Number(meuId) && (
                                                    <span className="badge bg-info">Você</span>
                                                )}
                                            </Link>

                                            <div className="text-muted small">
                                                Check-ins: {m.checkins}
                                            </div>

                                            <div className="small">Todos: {m.emojis.join(" ")}</div>
                                            <div className="small">Hoje: {m.emojis_hoje.join(" ")}</div>
                                            <div className="small">Semana: {m.emojis_semana.join(" ")}</div>
                                        </div>
                                    </div>

                                    {Number(meuId) === Number(grupo.criador) &&
                                        Number(m.aluno) !== Number(grupo.criador) && (
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => openModalRemocao(m)}
                                                title="Remover membro"
                                            >
                                                <i className="bi bi-person-x"></i> Remover
                                            </button>
                                        )}
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>

            {/* MODAL SAIR DO GRUPO */}
            {grupo && Number(meuId) !== Number(grupo.criador) && (
                <div className="modal fade" id="modalSairDoGrupo" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-danger text-white">
                                <h5 className="modal-title">⚠️ Confirmar Saída</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>

                            <div className="modal-body">
                                <p>
                                    Você tem certeza que deseja sair do grupo <b>{grupo.nome}</b>?<br />
                                    Você perderá acesso imediato aos recursos.
                                </p>
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-secondary" data-bs-dismiss="modal">
                                    Cancelar
                                </button>
                                <button className="btn btn-danger" onClick={confirmarSaida}>
                                    Sair do grupo
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL REMOVER MEMBRO */}
            <div className="modal fade" id="modalRemoverMembro" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-danger text-white">
                            <h5 className="modal-title">⚠️ Confirmar Remoção</h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" />
                        </div>

                        <div className="modal-body">
                            {membroSelecionado && (
                                <p>
                                    Remover <b>{membroSelecionado.nome}</b> do grupo?<br />
                                    Ele perderá acesso imediatamente.
                                </p>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-bs-dismiss="modal">
                                Cancelar
                            </button>
                            <button className="btn btn-danger" onClick={confirmarRemocao}>
                                Remover
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
